import './import-contact.dialog.component.scss'
import '../../../customers/component/customers-list/customers-list.scss'
import '../../../customers/route/Customers.scss'

export class ImportContactDialogComponent {

    public static instance = {
        controller: [
            '$mdDialog',
            ImportContactDialogComponent
        ],
        template: require('./import-contact.dialog.component.html'),
        bindings: {
            title: '@'
        },
        transclude: {
            logsTable: 'logsTable'
        },
        bindToController: true,
        controllerAs: '$ctrl',
    };

    protected title: string;

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    closeDialog = () => {
        this.$mdDialog.hide();
    }

}